<script lang="ts">
  import type { Guide } from "../../types";

  export let guide: Guide;
  export let tag = "div";
  export let style = "";
</script>

<svelte:element
  this={tag}
  class="Booklet"
  style="--cover-color: {guide.coverColor}; --cover-text-color: {guide.coverTextColor}; {style}"
  {...$$restProps}
>
  {#if guide.coverImage}
    <img alt={guide.title} class="CoverImage" height="420" src={guide.coverImage} width="240" />
  {:else}
    <span class="CoverText">
      {guide.title}
    </span>
  {/if}
</svelte:element>

<style>
  .Booklet {
    aspect-ratio: 240 / 420;
    background-color: var(--cover-color, --theme-color);
    border-radius: 12px;
    box-shadow:
      0px 3px 18px 0px rgba(0, 0, 0, 0.25),
      inset 0px 0px 3px 0px rgba(0, 0, 0, 0.5);
    color: var(--cover-text-color, inherit);
    font-size: min(max(20px, 5vh), 60px);
    font-weight: 600;
    max-height: 100%;
    position: relative;
    scroll-snap-align: start;
    text-decoration: none;
  }

  .CoverImage {
    border-radius: inherit;
    height: 100%;
    left: 0;
    object-fit: contain;
    position: absolute;
    top: 0;
    width: 100%;
  }

  .CoverText {
    align-items: center;
    display: flex;
    font-size: min(max(20px, 5vh), 60px);
    height: 100%;
    justify-content: center;
    line-height: 1.2em;
    text-align: center;
    padding: 0 48px;
    position: absolute;
    top: 0;
    width: 100%;
  }
</style>
